/** Human-friendly date helpers. SQL returns ISO timestamps; UI shows en-GB short form. */

export function formatDate(value: string | null | undefined): string {
  if (!value) return "";
  const d = new Date(value);
  if (isNaN(d.getTime())) return String(value).slice(0, 10);
  return d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
}

export function formatDateRow(value: string | null | undefined): string {
  if (!value) return "";
  const d = new Date(value);
  if (isNaN(d.getTime())) return String(value).slice(0, 10);
  return d.toLocaleDateString("en-GB", { weekday: "short", day: "2-digit", month: "short" });
}

export function formatRange(start: string | null | undefined, end: string | null | undefined): string {
  const a = formatDate(start);
  const b = formatDate(end);
  if (a && b) return `${a} to ${b}`;
  return a || b || "";
}

export function formatMoney(n: number | string | null | undefined): string {
  const v = Number(n ?? 0);
  return "£" + v.toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
